export const Constants = {
  API_ENDPOINT: process.env.REACT_APP_API_ENDPOINT,
  key: process.env.REACT_APP_API_KEY,
  loginRedirectUrl: process.env.REACT_APP_LOGIN_REDIRECT_URL,
  logoutRedirectUrl: process.env.REACT_APP_LOGOUT_REDIRECT_URL,
  msilChatbotUrl: process.env.MSIL_CHATBOT_URL,
  xApiKey: process.env.REACT_APP_X_API_KEY,
  clientId: process.env.REACT_APP_CLIENT_ID,
  msilLoginUrl: process.env.REACT_APP_LOGIN_URL,
};
